import { useConversation } from "@elevenlabs/react";
import * as React from "react";
import { Agent } from "@/new-pages/agents/types";
import { IconButton } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Stack from "@mui/material/Stack";
import { XIcon } from "@phosphor-icons/react/dist/ssr/X";

export interface PopupAgentModalProps {
	open: boolean;
	onClose: () => void;
	agent: Agent;
}

export function PopupAgentModal({ open, onClose, agent }: PopupAgentModalProps): React.JSX.Element {
	const conversation = useConversation();


	const click = async () => {
		if (conversation.status === "disconnected") {
			const response = await fetch(agent.testUrl, {
				method: "POST",
				headers: { Accept: "application/json" },
			});
			const { origin } = (await response.json()) as { origin: string };
			await conversation.startSession({
				connectionType: "websocket",
				signedUrl: origin,
			});
		} else {
			await conversation.endSession();
		}
	};

	const onClose2 = ()=>{
		if (conversation.status !== 'disconnected') {
			conversation.endSession().catch(console.error);
		}
		onClose()
	}
	return (
		<Dialog open={open} onClose={onClose2}>
			<DialogTitle>
				{" "}
				<IconButton color="inherit" onClick={onClose} sx={{ position: "absolute", right: 8, top: 8 }}>
					<XIcon width={20} height={20} />
				</IconButton>
			</DialogTitle>
			<DialogContent sx={{ p: 3 }}>
				<Stack direction="row" spacing={2} sx={{ display: "flex" }}>
					Popup
				</Stack>
			</DialogContent>
			{/* // can remove this if you want */}
			<DialogActions sx={{ p: 3, pt: 0 }}>
				<Stack direction="row" spacing={2} sx={{ justifyContent: "flex-end" }}>
					<Button color="secondary" onClick={onClose}>
						Cancel
					</Button>
					<Button color="primary" variant="contained" onClick={click}>
						{conversation.status}
					</Button>
				</Stack>
			</DialogActions>
		</Dialog>
	);
}
